export const accountOverviewCardLabels = {
  'LOAN-INSTALLMENT': {
    BALANCE_REMAINING: 'BALANCE_REMAINING',
    NO_OF_CONTRACTS: 'NO_OF_CONTRACTS',
    TOTAL_PAYMENT: 'TOTAL_PAYMENT',
    BADGE_COLOR: 'success',
  },
  LEASE: {
    BALANCE_REMAINING: 'BALANCE_REMAINING',
    NO_OF_CONTRACTS: 'NO_OF_CONTRACTS',
    TOTAL_PAYMENT: 'TOTAL_RENTALS',
    BADGE_COLOR: 'warning',
  },
  'LOAN-HIRE-PURCHASE': {
    BALANCE_REMAINING: 'BALANCE_REMAINING',
    NO_OF_CONTRACTS: 'NO_OF_CONTRACTS',
    TOTAL_PAYMENT: 'TOTAL_PAYMENT',
    BADGE_COLOR: 'default',
  },
};
